<script>
import widgetWrapper from '@/components/widgets/common/widgetWrapper';
import {h, resolveComponent} from "vue";

export default {
  name: 'widgetList',
  components: {widgetWrapper},
  emits: ['more', 'click'],
  render() {
    const {$theme, items} = this;
    const {title, subtitle, dateItem, lists, more, info} = items;
    const cLabel = resolveComponent('c-label')
    const legoIcon = resolveComponent('lego-icon')
    const widgetWrapper = resolveComponent('widget-wrapper')

    const widgetList = lists.map((list, idx) => {
      return h(
          'div',
          {
            class: 'widget-list-list',
            key: idx,
          },
          [
            h('div', {class: 'widget-list-list__name'}, [
              h(
                  cLabel,
                  {
                    pointer: true, ellipsis: true, size: 16, color: $theme.COLOR.UI.UI01,
                    onClick: () => {
                      this.onClick(list);
                    },
                  },
                  () => [list.name],
              ),
            ]),
            h('div', {class: 'widget-list-list__date'}, [
              h(cLabel, {color: $theme.COLOR.UI.UI01}, () => [list.date]),
            ]),
            h(legoIcon, {
              iconType: 'df',
              icon: 'arrow_right',
              size: 16,
              onClick: () => {
                this.onClick(list);
              },
            }),
          ],
      );
    });

    const widgetListContainer = h('div', {class: 'widget-list'}, [widgetList]);

    return h(
        widgetWrapper,
        {
          title, subtitle, dateItem, more, info,
          onMore: more => {
            this.$emit('more', more);
          },
        },
        () => [widgetListContainer],
    );
  },
  methods: {
    onClick(list) {
      //console.log('click');
      this.$emit('click', list);
    },
  },
  props: {
    items: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.widget-list {
  height: 100%;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;

  &-list {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $color--ui10;
    padding: 8px 20px 8px;
    cursor: pointer;

    &:hover {
      .widget-list-list__name .c-label {
        color: $color--primary !important;
      }
    }

    &:active {
      .widget-list-list__name .c-label {
        color: $color--primary !important;
      }
    }

    &:nth-of-type(1) {
      margin-top: 0;
    }

    &:nth-last-of-type(1) {
      border: 0;
    }

    &__name {
      display: flex;
      width: calc(100% - 90px);
    }

    &__date {
      width: 90px;
    }
  }
}
</style>
